import React from "react";

/**
 * component svg
 */
const ManualScreeningIcon = function (props) {

    return (
        <svg id="manual-screening" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
            <path className="st0-msi" d="M327.9,827.9c0,0.1,0.1,0.3,0.1,0.4L97.5,911.8c-5.7,2.1-11.3-3.5-9.2-9.2l83.6-230.6c0.1,0,0.2,0.1,0.4,0.1
                C250.7,698.5,301.7,749.5,327.9,827.9z"/>
            <path className="st0-msi" d="M824.8,341.6L366.1,800.3c-4.2,4.2-11.4,2.8-13.6-2.8c-28.8-70.7-79.2-121-150-149.9c-5.5-2.3-7-9.4-2.8-13.6l458.7-458.7
                c4.8-4.8,12-6.3,18.5-4c0,0,0.1,0,0.1,0C753.6,197,803.2,246.6,828.8,323c0,0,0,0.1,0,0.1C831.1,329.6,829.6,336.8,824.8,341.6z"/>
            <path className="st0-msi" d="M882.5,283.9l-13.6,13.6c-29.9-80.4-85.8-136.3-166.4-166.4l13.6-13.6c45.6-45.6,119.7-46.2,165.5-0.7
                c0.5,0.5,1.1,1.1,1.6,1.6C928.7,164.4,928.1,238.3,882.5,283.9z"/>
        </svg>
    );
};

export default ManualScreeningIcon;
